// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2B00k","footer":"ModalInfo_footer__3UOvK"};